import clsx from "clsx";
import {
  CheckCircle2,
  Clock,
  FileSpreadsheet,
  XCircle,
  type LucideIcon,
} from "lucide-react";

import { Card } from "../../../../shared/card/card.tsx";
import type { ApprovalStats } from "../../types.ts";

import styles from "./approval-dashboard-stats.module.css";

export interface ApprovalDashboardStatsProps {
  stats: ApprovalStats;
  loading?: boolean;
}

interface Tile {
  key: keyof ApprovalStats | "totalTimesheets";
  label: string;
  value: number;
  icon: LucideIcon;
  iconClass: string;
}

export function ApprovalDashboardStats({
  stats,
  loading,
}: ApprovalDashboardStatsProps) {
  const tiles: Tile[] = [
    {
      key: "totalTimesheets",
      label: "Total Timesheets",
      value: stats.totalTimesheets,
      icon: FileSpreadsheet,
      iconClass: styles.iconPurple,
    },
    {
      key: "pendingTotal",
      label: "Pending",
      value: stats.pendingTotal,
      icon: Clock,
      iconClass: styles.iconAmber,
    },
    {
      key: "approvedTotal",
      label: "Approved",
      value: stats.approvedTotal,
      icon: CheckCircle2,
      iconClass: styles.iconGreen,
    },
    {
      key: "rejectedTotal",
      label: "Rejected",
      value: stats.rejectedTotal,
      icon: XCircle,
      iconClass: styles.iconRed,
    },
  ];

  return (
    <div className={styles.grid} aria-busy={loading ? true : undefined}>
      {tiles.map(({ key, label, value, icon: Icon, iconClass }) => (
        <Card key={key} className={styles.card} padding="3xl" variant="default">
          <div className={styles.cardInner}>
            <span className={clsx(styles.iconWrap, iconClass)} aria-hidden>
              <Icon size={20} strokeWidth={2} />
            </span>
            <div className={styles.text}>
              <p className={clsx("sub-heading-xs", styles.label)}>{label}</p>
              <p className={clsx("heading-lg", styles.value)}>
                {loading ? "—" : value.toLocaleString()}
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}

export default ApprovalDashboardStats;
